import { Outlet, useOutletContext } from 'react-router';

type TicketOutletContext = {
    refetchTicketState: () => void;
};

export function useTicketOutletContext() {
    return useOutletContext<TicketOutletContext>();
}

export function TicketOutlet({ context }: { context: TicketOutletContext }) {
    return <Outlet context={context} />;
}
